export default {
  DNI: 'DNI',
  LC: 'LC',
  LE: 'LE',
  PAS: 'PAS',
  CI: 'CI'
};
